export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PersonalDataAgreement.vue?vue&type=template&id=57f567da&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/PersonalDataAgreement.vue?vue&type=template&id=57f567da&
// module id = 1133
// module chunks = 0